// extracted by mini-css-extract-plugin
export default {"Loading":"bcz_a bii_a bii_w bii_j bii_ul bii_um bii_fm"};